<template>
  <v-text-field
    :class="customClass"
    outlined
    dense
    rounded
    color="primary"
    class="stretch-append text-field-styling align-self-stretch"
    :value="value"
    @input="update"
    :label="label"
    :rules="rules == null ? [] : rules"
    :type="type == 'password' ? (showPassword ? 'text' : 'password') : type"
    @blur="$emit('blur')"
  >
    <template slot="prepend-inner">
      <slot name="text-field-prepend-inner"></slot>
    </template>

    <template v-slot:append>
      <slot name="text-field-append">
        <label class="my-auto cursor-pointer text-caption" @click="type == 'password' ? (showPassword = !showPassword) : (showPassword = !showPassword)" v-if="type == 'password'">
          {{ showPassword ? $t('label.hide') : $t('label.show') }}
        </label>
      </slot>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'AppTextField',
  data: () => ({
    showPassword: false
  }),
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      required: true
    }
  },
  methods: {
    update(newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>
